import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    language: {
      text: 'English',
      value: 'en'
    },
    supportedLanguages: [
      {
        key: 'en',
        text: 'English',
        value: 'en'
      },
      {
        key: 'nl',
        text: 'Nederlands',
        value: 'nl'
      }
    ]

  },
  mutations: {
    language (state, language) {
      state.language.value = language.value
      state.language.text = language.text
    }
  },
  getters: {
    language: state => {
      return state.language
    },
    supportedLanguages: state => {
      return state.supportedLanguages
    }
  }
})

new Vue({ // eslint-disable-line no-new
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js